import React from 'react';
import SafeIcon from '../../common/SafeIcon';
import { Icons } from '../icons';

// File picker/dropzone. `accept` mirrors the PocketBase mimeTypes; files
// over `maxSize` (bytes) are rejected client-side with a message via the
// optional onReject callback.
export default function FileDropzone({ onFiles, preview, accept, multiple = true, maxSize = 10 * 1024 * 1024, onReject, hint }) {
  const handle = (files) => {
    const tooBig = files.filter((file) => file.size > maxSize);
    if (tooBig.length && onReject) {
      onReject(tooBig.map((file) => `${file.name} is larger than ${Math.round(maxSize / 1024 / 1024)} MB`));
    }
    onFiles(files.filter((file) => file.size <= maxSize));
  };

  return (
    <label className="file-dropzone">
      {preview ? <img src={preview} alt="Preview" /> : (
        <span className="dropzone-copy">
          <SafeIcon icon={Icons.Upload} />
          <span>Drop files here or click to browse</span>
          {hint && <small>{hint}</small>}
        </span>
      )}
      <input
        type="file"
        multiple={multiple}
        accept={accept}
        onChange={(event) => {
          handle(Array.from(event.target.files || []));
          event.target.value = ''; // allow re-picking the same file
        }}
      />
    </label>
  );
}
